import React from "react";
import { Headphones, Download } from "lucide-react";

export function TrackStats({ track, className = "" }) {
  return (
    <div className={`hidden sm:flex items-center gap-3 font-mono text-[10px] text-white/45 shrink-0 ${className}`} data-testid={`track-stats-${track.id}`}>
      <span className="flex items-center gap-1" title="Reproducciones"><Headphones className="w-3 h-3" />{track.play_count || 0}</span>
      <span className="flex items-center gap-1" title="Descargas"><Download className="w-3 h-3" />{track.download_count || 0}</span>
    </div>
  );
}
